import Vue from "vue";

const searchServiceScopes = [process.env.VUE_APP_SEARCH_SCOPE];

// const auth = new Msal.UserAgentApplication(
//   process.env.VUE_APP_AUTH_CLIENT_ID,
//   process.env.VUE_APP_AUTH_AUTHORITY,
//   authCallback,
//   {
//     redirectUri:
//       (window.location.hostname == "localhost" ? "http://" : "https://") +
//       window.location.host +
//       "/login",
//     //logger: logger,
//     storeAuthStateInCookie: true,
//     cacheLocation: "localStorage",
//     navigateToLoginRequestUrl: false
//   }
// );

function login() {
  if (!Vue.prototype.$auth.getUser()) {
    return new Promise(resolve => {
      resolve(Vue.prototype.$auth.loginRedirect());
    });
  } else {
    Promise.resolve(Vue.prototype.$auth.getUser());
  }
}

// eslint-disable-next-line no-unused-vars
function authCallback(errorDesc, token, error, tokenType) {
  // if (error) {
  //   alert(error);
  //   alert(errorDesc);
  // }
  // console.log("AUTH (callback)", Vue.$auth);
  // // eslint-disable-next-line
  // console.log("AUTH CALLBACK", errorDesc, token, error, tokenType);
  //getAncillaryTokens();
}

function acquireTokenSilent() {
  var token = Vue.prototype.$auth.getAccessToken();
  if (token == undefined)
  {
    acquireTokenPopup();
  }
  else return new Promise(resolve=> {resolve(token)});
  //var user = Vue.prototype.$auth.getUser();
  //console.log(user);
  console.log(token);
  // return Vue.prototype.$auth
  //   .getAccessToken(scopes)
  //   .then(token => {
  //     return token;
  //   })
  //   .catch(() => {
  //     acquireTokenPopup(scopes);
  //   });
}
function acquireTokenPopup() {
  return new Promise(resolve => {
    resolve(Vue.prototype.$auth.getAccessToken());
  });
  // Vue.$auth.acquireTokenPopup(scopes);
  // .then(token => {
  //   return token;
  // })
  // .catch(err => {
  //   error.newError(err);
  // });
}

function getSearchToken() {
  return !!Vue.prototype.$auth && Vue.prototype.$auth.getUser()
    ? acquireTokenSilent()
    : acquireTokenPopup();
}

async function getSearchRoles() {
  return getSearchToken().then(t => {
    console.log("search roles");
    let jwtData = t.split(".")[1];
    let decodedJwt = window.atob(jwtData);
    let data = JSON.parse(decodedJwt);
    console.log(data.role);
    return data.role;
  });
}

function getUser() {
  return Vue.prototype.$auth.getUser();
}

export default {
  login,
  getUser,
  getSearchToken,
  getSearchRoles
};
